import React, { useEffect, useState } from 'react'
import { Box, Chip, Divider, Icon, Typography } from '@mui/material'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import AdxInputEdit from 'components/custom/AdxInputEdit'
import AdxSwitch from 'components/reusable/switch/AdxSwitch'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getAllForm, getForm } from 'services/api/modules/performance/appraisal/form'
import { getAllDepartment } from 'services/api/modules/performance/appraisal/department'
import {
  getEvaluation,
  saveEvaluation,
} from 'services/api/modules/performance/appraisal/evaluation'
import AdxStatusBar from 'components/reusable/statusBar/AdxStatusBar'
import AdxDropdown from 'components/custom/AdxDropdown'
import AdxMenuItem from 'components/custom/AdxMenuItem'
import AdxDropdownWithFilter from 'components/reusable/AdxDropdownWithFilter'
import AdxMultiselectWFilter from 'components/custom/AdxMultiselectWFilter'
import AdxMenuItemCreateEval from 'components/custom/AdxMenuItemCreateEval'
import EvaluationSnackBar from '../components/EvaluationSnackBar'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const matching = [
  { id: 1, name: 'Self - Reviewer and Reviewee will be the same person' },
  { id: 2, name: 'Downstream - Supervisor as reviewer and Subordinate as reviewee' },
  { id: 3, name: 'Upstream - Subordinate as reviewer and Supervisor as reviewee' },
  {
    id: 4,
    name: 'Custom - Upload external matching CSV when this evaluation is added to an appraisal',
  },
]

function EditEvaluation() {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const evalId = pathname.split('/').pop()
  const [evaluationTitle, setEvaluationTitle] = useState('')
  const [description, setDescription] = useState('')
  const [getQuery, setGetQuery] = useState(false)
  const [switchFeedback, setSwitchFeedback] = useState(true)
  const [selectReviewer, setSelectReviewer] = useState(false)
  const [selectReviewee, setSelectReviewee] = useState(false)
  const [switchAnonymous, setSwitchAnonymous] = useState(false)
  const [selectForm, setSelectForm] = useState('')
  const [selectFormId, setSelectFormId] = useState('')
  const [selectDepartment, setSelectDepartment] = useState([])
  const [selectDepartmentId, setSelectDepartmentId] = useState([])
  const [selectMatching, setSelectMatching] = useState('')
  const [formList, setFormList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [departmentAll, setDepartmentAll] = useState(false)
  const [checkAllDept, setCheckAllDept] = useState([])
  const [excludeAllDeptList, setExcludeAllDeptList] = useState([])
  const [showDept, setShowDept] = useState([])
  const [showError, setShowError] = useState(false)
  const [getError, setGetError] = useState()

  const [dropdownFilterOptionsForm, setDropDownFilterOptionsForm] = useState(formList)
  const [dropdownFilterOptionsDept, setDropDownFilterOptionsDept] = useState(departmentList)

  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.invalidateQueries('editEvalData')
    queryClient.invalidateQueries('editAllDepartmentData')
    queryClient.invalidateQueries('editEvalFormData')
    queryClient.invalidateQueries('editEvalDepartmentData')
  }, [])

  const { data: evaluationData } = useQuery(['editEvalData', evalId], async () => {
    const { data } = await getEvaluation(evalId)
    return data
  })

  const { data: editEvalFormData } = useQuery(
    ['editEvalFormData', evaluationData?.['Evaluation']?.['form_id']],
    async () => {
      const { data } = await getForm(evaluationData?.['Evaluation']?.['form_id'])
      return data
    },
    { enabled: getQuery }
  )

  const { data: editEvalDepartmentData } = useQuery(
    ['editEvalDepartmentData', evaluationData?.['Evaluation']?.['participant_departments']],
    async () => {
      const newData = { name: 'All Departments', id: 'all' }
      let { data } = await getAllDepartment()
      if (data) {
        data.push(newData)
        const evalDepartments = evaluationData?.['Evaluation']?.['participant_departments']
        let arr = []
        data?.map((item) =>
          evalDepartments.map((evalDept) => (item.id === evalDept ? arr.push(item) : null))
        )
        data = arr
        return data
      }
    },
    { enabled: getQuery }
  )

  const { data: editAllFormData } = useQuery('editAllFormData', async () => {
    const { data } = await getAllForm()
    return data
  })

  const { data: editAllDepartmentData } = useQuery('editAllDepartmentData', async () => {
    let newData = [{ name: 'Select All Departments', id: 'all' }]
    const { data } = await getAllDepartment()
    setExcludeAllDeptList(data)
    data.map((item, index) => newData.push(data[index]))
    return newData
  })

  useEffect(() => {
    const data = evaluationData?.['Evaluation']
    data ? setGetQuery(true) : setGetQuery(false)
    setEvaluationTitle(data?.['title'])
    setDescription(data?.['description'])
    setSelectMatching(data?.['participant_match_type_id'])

    data?.['has_feedback'] === 1 ? setSwitchFeedback(true) : setSwitchFeedback(false)

    data?.['is_anonymous'] === 1 ? setSwitchAnonymous(true) : setSwitchAnonymous(false)

    data?.['is_revieweeView'] === 1 ? setSelectReviewee(true) : setSelectReviewee(false)

    data?.['is_reviewerView'] === 1 ? setSelectReviewer(true) : setSelectReviewer(false)
  }, [evaluationData])

  useEffect(() => {
    setSelectForm(editEvalFormData?.['form'])
    setSelectFormId(editEvalFormData?.['form']?.['id'])
    let showDepartment = []
    let department = []

    editEvalDepartmentData?.map((i) => {
      department.push(i.id)
      showDepartment.push(i)
    })
    setSelectDepartmentId([...new Set(department)])
    setSelectDepartment(
      showDepartment.find((element) => element.id === 'all')
        ? editAllDepartmentData
        : showDepartment
    )
    setShowDept(showDepartment)
    setCheckAllDept(
      showDepartment.find((element) => element.id === 'all')
        ? editAllDepartmentData
        : showDepartment
    )

    if (selectDepartment.find((object) => object.id === 'all')) {
      setDepartmentAll(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editEvalFormData, editEvalDepartmentData])

  useEffect(() => {
    setFormList(editAllFormData?.form ?? [])
    setDepartmentList(editAllDepartmentData ?? [])
  }, [editAllFormData, editAllDepartmentData])

  const handleReviewer = () => {
    setSelectReviewer(!selectReviewer)
  }

  const handleReviewee = () => {
    setSelectReviewee(!selectReviewee)
  }

  const onChangeTitle = (event) => {
    setEvaluationTitle(event.target.value)
  }
  const onChangeDesc = (event) => {
    setDescription(event.target.value)
  }

  const handleMatchingSelection = (event) => {
    setSelectMatching(event.target.value)
  }

  const handleFormSelection = (event) => {
    setSelectForm(event.target.value)
    setSelectFormId(event.target.value.id)
  }

  const handleDepartmentSelection = (event) => {
    let department = []
    const specificObject = { name: ' All Departments', id: 'all' }

    let {
      target: { value },
    } = event

    let filteredArr = value.reduce((unique, obj) => {
      if (!unique.some((item) => item.id === obj.id)) {
        return [...unique, obj]
      }
      return unique
    }, [])

    if (value.length !== filteredArr.length) {
      filteredArr.map((item, index) => {
        if (item.id === value[value.length - 1].id) {
          filteredArr.splice(index, 1)
        }
      })
    }

    // To check previous & current selection if "Select All Department" is selected or not. Initial value of checkAllDept will be []
    const deselectAllDept = checkAllDept.some(
      (element) =>
        element.id === specificObject.id &&
        !filteredArr.some((currentElement) => currentElement.id === specificObject.id)
    )
    setCheckAllDept(filteredArr)

    if (deselectAllDept) {
      filteredArr = []
    }

    if (!departmentAll) {
      if (filteredArr.find((object) => object.id === 'all')) {
        filteredArr = editAllDepartmentData
        setDepartmentAll(true)
      }
    } else {
      if (filteredArr.find((object) => object.id === 'all')) {
        filteredArr.splice(
          filteredArr.findIndex((obj) => obj.id === 'all'),
          1
        )
      }
      setDepartmentAll(false)
    }

    if (excludeAllDeptList.length === filteredArr.length) {
      filteredArr = editAllDepartmentData
      setCheckAllDept(filteredArr)
    }
    department = filteredArr.flatMap((i) => i.id)
    department = department.find((element) => element === 'all') ? ['all'] : department

    setSelectDepartmentId(department)
    setSelectDepartment(filteredArr)
    setShowDept(
      filteredArr.find((element) => element.id === 'all') ? [specificObject] : filteredArr
    )
  }

  const {
    isLoading: saveLoading,
    error: saveError,
    mutate: saveMutate,
  } = useMutation(saveEvaluation, {
    onSuccess: () => {
      navigate('/app/management-centre/company-management/appraisal')
    },
    onError: (error) => {
      if (Object.keys(error?.data?.errors).length > 1) {
        setGetError(Object.values('You have incomplete fields'))
      } else {
        setGetError('You have an incomplete field')
      }
      setShowError(true)
    },
  })

  const handleCreateEval = () => {
    const updateEval = {
      title: evaluationTitle,
      is_anonymous: switchAnonymous ? 1 : 0,
      is_revieweeView: selectReviewee ? 1 : 0,
      is_reviewerView: selectReviewer ? 1 : 0,
      has_feedback: switchFeedback ? 1 : 0,
      form_id: selectForm.id,
      matching_id: selectMatching,
      ...(description && { description: description }),
      ...(selectDepartmentId.length > 0 && { department_ids: selectDepartmentId }),
    }

    saveMutate({ evaluationId: evalId, data: updateEval })
  }

  return (
    <Box
      sx={{
        backgroundColor: 'gray-background.main',
        minHeight: '100vh',
        maxWidth: '100vw',
        gap: 2,
        pb: 3,
      }}
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      {/* Header */}
      <Box
        sx={{
          width: '100%',
          height: 75,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          backgroundColor: 'white.main',
          borderBottom: '1px solid',
          borderBottomColor: 'gray-line.main',
          position: 'sticky',
          top: 0,
          zIndex: 999,
        }}
        px={'40px'}
      >
        <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
          <Typography variant="h4">{evaluationTitle}</Typography>
          <AdxStatusBar
            status={{
              text: 'Edit',
              color: 'alternate.main',
              bgColor: 'alternate.light',
            }}
            py={1 / 3}
            sx={{ borderRadius: '4.5px' }}
          />
        </Box>
        <Box display="flex" alignItems="center" gap={2}>
          <AdxButton
            variant={'contained'}
            sx={{ width: 135 }}
            size="small"
            onClick={handleCreateEval}
            disabled={saveLoading ? true : false}
          >
            {saveLoading ? 'Saving...' : 'Save'}
          </AdxButton>
          <Icon
            onClick={() => {
              navigate('/app/management-centre/company-management/appraisal')
              // window.location.reload(false)
            }}
            sx={{ fontSize: 25, cursor: 'pointer' }}
          >
            close
          </Icon>
        </Box>
      </Box>
      <EvaluationSnackBar
        message={getError}
        status={'error'}
        autoHideDuration={4000}
        showError={showError}
        setShowError={setShowError}
      />

      {/* Body */}
      {/* General */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            General
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Name</Typography>
            <AdxInputEdit
              value={evaluationTitle}
              charLimit={50}
              onChange={onChangeTitle}
              isErrorShown={saveError?.data?.errors?.title}
              errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.title} />}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Description</Typography>
            <AdxInputEdit
              multiline
              value={description}
              charLimit={500}
              onChange={onChangeDesc}
              isErrorShown={saveError?.data?.errors?.description}
              errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.description} />}
            />
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Typography variant="body1">Evaluation Form Selection</Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <AdxDropdownWithFilter
                allOptions={formList}
                setOptions={setDropDownFilterOptionsForm}
                sx={{ width: '500px' }}
                value={selectForm}
                onChange={handleFormSelection}
                renderValue={(option) => {
                  return (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Typography variant="body1">{option.title}</Typography>
                      </Box>
                    </Box>
                  )
                }}
                isErrorShown={saveError?.data?.errors?.form_id}
                errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.form_id} />}
              >
                {dropdownFilterOptionsForm.map((item, index) => (
                  <AdxMenuItemCreateEval key={index} value={item} selectedvalue={selectForm}>
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'flex-start',
                        }}
                      >
                        <Typography variant="body1">{item.title}</Typography>
                      </Box>
                    </Box>
                  </AdxMenuItemCreateEval>
                ))}
              </AdxDropdownWithFilter>

              <Link
                to={`/app/management-centre/company-management/appraisal/form/preview/${selectFormId}`}
                target="_blank"
                style={{ textDecoration: 'none', color: 'white' }}
              >
                <AdxButton
                  variant={'contained'}
                  x={{ width: 200 }}
                  size="standard"
                  // onClick={handlePreview}
                >
                  Preview
                </AdxButton>
              </Link>
            </Box>
          </Box>
        </Box>
      </Box>

      {/* Participant */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Participant
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {/* Select Departments */}
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography variant="body1">Department Selection</Typography>
            </Box>
            <AdxMultiselectWFilter
              allOptions={departmentList}
              setOptions={setDropDownFilterOptionsDept}
              multiple
              sx={{ width: '100%' }}
              value={selectDepartment}
              onChange={handleDepartmentSelection}
              renderValue={() => {
                return (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      overflowX: 'auto',
                    }}
                  >
                    {showDept.map((value) => (
                      <Chip key={value.id} label={value.name} />
                    ))}
                  </Box>
                )
              }}
              isErrorShown={saveError?.data?.errors?.department_ids}
              errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.department_ids} />}
            >
              {dropdownFilterOptionsDept.map((item, index) => (
                <AdxMenuItemCreateEval key={index} value={item} selectedvalue={selectDepartment}>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <Typography variant="body1">{item.name}</Typography>
                  </Box>
                </AdxMenuItemCreateEval>
              ))}
            </AdxMultiselectWFilter>
          </Box>
          {/* Matching rule */}
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Typography variant="body1">Matching Method </Typography>
            </Box>
            <AdxDropdown
              sx={{ width: '100%' }}
              sxLabel={{
                color: 'alternate.main' /*, fontSize: "30px!important" */,
                fontSize: '30px',
              }}
              value={selectMatching}
              onChange={handleMatchingSelection}
              isErrorShown={saveError?.data?.errors?.matching_id}
              errorMessage={<AdxErrorMessage children={saveError?.data?.errors?.matching_id} />}
            >
              {matching.map((item, index) => (
                <AdxMenuItem key={index} value={item?.['id']} selectedvalue={selectMatching}>
                  {item?.['name']}
                </AdxMenuItem>
              ))}
            </AdxDropdown>
          </Box>
        </Box>
      </Box>
      {/* Other */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          backgroundColor: 'white.main',
          width: '67%',
          borderRadius: '4.5px',
          boxShadow: '0px 0px 10px lightgray',
        }}
      >
        <Box sx={{ p: 3, borderBottom: 1, borderColor: 'gray-line.main' }}>
          <Typography variant="h4" color="alternate.main" fontWeight="600">
            Other
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, px: 3, pt: 2, pb: 3 }}>
          {/* Feedback visibility */}
          {/* <Box>
            <Typography variant="body1">Evaluation Result Visibility:</Typography>
            <Typography variant="subtitle2" color="gray">
              Evaluation results will be visible to the selected type of user(s).
            </Typography>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <AdxFormControlLabel
              type="no-fill"
              control={<AdxCheckbox onChange={handleReviewer} checked={selectReviewer} />}
              label="Reviewer"
            />
            <AdxFormControlLabel
              type="no-fill"
              control={<AdxCheckbox onChange={handleReviewee} checked={selectReviewee} />}
              label="Reviewee"
            />
          </Box> */}

          {/* Enabling evaluation feedback */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Evaluation feedback</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to leave feedback after they have reviewed their evaluation result.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchFeedback}
              onChange={() => {
                setSwitchFeedback(!switchFeedback)
              }}
            />
          </Box>

          {/* Anonymous submission */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Typography variant="body1">Anonymous submission</Typography>
              <Typography variant="subtitle2" color="gray">
                Reviewee is able to submit evaluation anonymously.
              </Typography>
            </Box>
            <AdxSwitch
              label1="Enabled"
              label2="Disabled"
              state={switchAnonymous}
              onChange={() => {
                setSwitchAnonymous(!switchAnonymous)
              }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EditEvaluation
